import { Requests } from "../common/request.common";
import { DeviceResponseTypes, UserAttendanceResponseTypes } from "../common/response.common";
import { SelectParam } from "../common/types.common";
import { buildSelectParam, get, post, postEmpty } from "./common";

export const userAttendance = {
    record(data: typeof Requests.UserAttendance.Record.Input) {
        return post<typeof data, UserAttendanceResponseTypes.Record>(
            "/user-attendance/record",
            data,
        );
    },
    import(data: typeof Requests.UserAttendance.Import.Input) {
        return post<typeof data>("/user-attendance/import", data);
    },
    add(data: typeof Requests.UserAttendance.Add.Input) {
        return post<typeof data>("/user-attendance/create", data);
    },
    delete(id: string) {
        return postEmpty<DeviceResponseTypes.RunCommand>(`/user-attendance/delete/${id}`);
    },
    downloadTemplate() {
        return get("/user-attendance/import/download-template", {
            authenticated: true,
            downloadable: true,
            responseType: "blob",
        });
    },
    optionByDevice(deviceId: string) {
        return get<UserAttendanceResponseTypes.OptionByDevice>(
            `/user-attendance/option/by-device/${deviceId}`,
        );
    },
    optionExcludeByGroup(groupId: string) {
        return get<UserAttendanceResponseTypes.OptionExcludeByGroup>(
            `/user-attendance/option/by-group-exclude/${groupId}`,
        );
    },
    optionAll: async (params: SelectParam) => {
        return (
            (await get<UserAttendanceResponseTypes.OptionAll>(
                "/user-attendance/option/all" + buildSelectParam(params),
            ).execute()) ?? []
        );
    },
    accountCreate(id: string, data: typeof Requests.UserAttendance.AccountCreate.Input) {
        return post<typeof data>(`/user-attendance/account/create/${id}`, data);
    },
    accountUpdatePassword(
        id: string,
        data: typeof Requests.UserAttendance.AccountUpdatePassword.Input,
    ) {
        return post<typeof data>(`/user-attendance/account/update-password/${id}`, data);
    },
    accountUpdatePhone(id: string, data: typeof Requests.UserAttendance.AccountUpdatePhone.Input) {
        return post<typeof data>(`/user-attendance/account/update-phone/${id}`, data);
    },
    accountDeletePhone(id: string) {
        return postEmpty(`/user-attendance/account/delete-phone/${id}`);
    },
};
